import { FC, ReactNode } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

export interface LoadingBackdropProps {
  children?: ReactNode;
  open?: boolean;
}

export const LoadingBackdrop: FC<LoadingBackdropProps> = ({ children, open }) => {
  return (
    <Backdrop open={open === undefined ? true : open} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <CircularProgress color="primary" />
      {children}
    </Backdrop>
  );
};
